let langData2 = {
	"ru": {
        "title1": "Присоединяйся",
        "title1_2": "к Телеграм-боту",
				"title2": "и получай",
				"title-h1": "100",
				"title3": "кешбэка",
        "namePlaceholder": "Имя",
        "female": "Женщина",
        "male": "Мужчина",
        "genderStatus": "ж",
        "genderStatus2": "м",
        "subscribe": "Подписаться",
				"join": "Присоединиться",
        "discountDetail": "Детали акции",
        "discountDescr1": "*Предложение действует для клиентов, которые",
        "discountDescr2": "присоединились к Телеграм-боту Техно Еж впервые.",
        "policyText1": "Не волнуйся - твоя почта в безопасности.",
        "policyText2": "Будем писать тебе только о наших акциях и новостях.",
	},
	"ua": {
		"title1": "Приєднуйся",
		"title1_2": "до Телеграм-боту",
		"title2": "та отримуй",
		"title-h1": "100",
		"title3": "кешбеку",
		"namePlaceholder": "Ім'я",
		"female": "Жінка",
		"male": "Чоловік",
        "genderStatus": "ж",
        "genderStatus2": "м",
		"subscribe": "Підписатися",
		"join": "Приєднатись",
		"discountDetail": "Деталі акції",
		"discountDescr1": "*Пропозиція діє для клієнтів, що ",
		"discountDescr2": "приєднались до Телеграм-боту Техно Їжак вперше.",
		"policyText1": "Не хвилюйся - твоя пошта в безпеці.",
		"policyText2": "Писатимемо тобі тільки про наші акції та новини.",
	}
}

export default langData2